<script setup lang="ts">
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";

defineProps<{
  dtwin: Dtwin;
  deviceModelUiConfig: Record<string, DynamicUIDetail[]>;
}>();
const { t } = useI18n();
</script>

<template>
  <block-container
    :title="t('dtwins.form.description.characteristics.title')"
    with-top-separator
  >
    <template #left>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.left"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
    <template #right>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.right"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
  </block-container>
</template>
